<div *ngIf="alerts.length" class="container-fluid montserrat-medium position-fixed alert-container m-0 w-100 h-0"
    [ngClass]="showAsModal? 'position-fixed alert-container-modal h-100 top-0' : ''">
    <div *ngFor="let alert of alerts" class="box-alert text-center my-0 mx-auto shadow-lg {{cssClasses(alert)}}">
        <ng-container *ngIf="alert.Type != AlertType.InfoLogo; else DefaultAlert">
            <div class="d-flex">
                <div class="flex-grow-1 bd-highlight">
                    <h6>{{ alert.Title }}</h6>
                </div>
                <div><a class="text-decoration-none close text-danger" (click)="RunFunctionOnClose(alert)">x</a></div>
            </div>
            <hr class="mt-1">
        </ng-container>
        <ng-template #DefaultAlert>
            <div class="col-12 mb-3">
                <img loading="lazy" [src]="environment.assetsURL + brandResources.pathLogoBlack" width="4023" height="1451"  style="width: 10em; height: auto; display: block;" />
            </div>
        </ng-template>
        <span [innerHTML]="alert.Description"></span>

        <div class="text-center" *ngIf="alert.BtnText">
            <br>
            <a *ngIf="alert.BtnLink" class="btn btn-auth-custom border-0 w-75" [routerLink]="alert.BtnLink"
                (click)="removeAlert(alert)">{{ alert.BtnText }}</a>
            <a *ngIf="!alert.BtnLink" class="btn btn-auth-custom border-0 w-75"
                (click)="RunFunctionOnBtnClick(alert)">{{ alert.BtnText }}</a>
        </div>
    </div>
</div>
<div class="position-fixed fixed-top w-100 h-100 pt-5 montserrat-medium content-loading" *ngIf="loading?.showLoading && loading?.loadingType == LoadingType.Default">
    <div class="mb-5 text-center w-100 position-absolute bottom-0">
        <div class="col-md-12 loading-text fst-italic " *ngFor="let textLoading of loading?.textsLoading" bh-id="loading-txt">
            <label><strong>{{ textLoading }}</strong></label>
        </div>
        <div class="col-md-12 mt-2">
            <div class="spinner-grow m-1 text-dark" role="status">
                <span class="sr-only"></span>
            </div>
            <div class="spinner-grow m-1 custom-loading-icon-default" role="status">
                <span class="sr-only"></span>
            </div>
            <div class="spinner-grow m-1 custom-loading-icon-default" role="status">
                <span class="sr-only"></span>
            </div>
            <div class="spinner-grow m-1 text-light" role="status">
                <span class="sr-only"></span>
            </div>
        </div>
    </div>
</div>
<div class="position-fixed fixed-top w-100 h-100 montserrat-medium content-loading-laststep" *ngIf="loading?.showLoading && loading?.loadingType == LoadingType.Black">
    <div class="row vh-100 justify-content-around align-items-center">
        <div class="col-auto text-white text-center">
            Please wait while we create your {{ brandResources.brandTitle }} Profile. This will only take a moment.
        </div>
        <div class="mb-5 text-center position-absolute bottom-0">
            <div class="col-md-12 mt-2">
                <div class="spinner-grow m-1 text-dark" role="status">
                    <span class="sr-only"></span>
                </div>
                <div class="spinner-grow m-1 custom-loading-icon-default" role="status">
                    <span class="sr-only"></span>
                </div>
                <div class="spinner-grow m-1 custom-loading-icon-default" role="status">
                    <span class="sr-only"></span>
                </div>
                <div class="spinner-grow m-1 text-light" role="status">
                    <span class="sr-only"></span>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="position-fixed fixed-top w-100 h-100 montserrat-medium content-loading pt-5" *ngIf="loading?.showLoading && loading?.loadingType == LoadingType.WhiteBox" bh-id="loading-modal">
    <div class="row mt-5">
        <div class="col-md-8 offset-md-2 mt-md-5 px-4 px-md-0">
            <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4 bg-light rounded text-center p-3 mt-5">
                <div class="col-md-12 loading-text-white-box" *ngFor="let textLoading of loading?.textsLoading">
                    <h3 class="montserrat-bold">{{ textLoading }}</h3>
                </div>
                <div class="col-md-12 mt-4">
                    <div class="spinner-grow m-1 custom-loading-icon-whitebox text-dark" role="status">
                        <span class="sr-only"></span>
                    </div>
                    <div class="spinner-grow m-1 custom-loading-icon-whitebox custom-loading-icon-whitebox-1" role="status">
                        <span class="sr-only"></span>
                    </div>
                    <div class="spinner-grow m-1 custom-loading-icon-whitebox custom-loading-icon-whitebox-2" role="status">
                        <span class="sr-only"></span>
                    </div>
                    <div class="spinner-grow m-1 custom-loading-icon-whitebox custom-loading-icon-whitebox-3" role="status">
                        <span class="sr-only"></span>
                    </div>
                </div>
                <div class="col-md-12">
                    <p class="montserrat-semibold m-4 custom-loading-text-whitebox">Validating your information may take up to 45 seconds.</p>
                </div>
                <div class="col-md-12">
                    <p class="montserrat-regular m-0 mx-3 custom-loading-text-whitebox">Please do not click the "back" button or close the browser at this time.</p>
                </div>
            </div>
        </div>
    </div>
</div>